import { render, staticRenderFns } from "./Tributos.vue?vue&type=template&id=739f8822&"
import script from "./Tributos.vue?vue&type=script&lang=js&"
export * from "./Tributos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports